<template>
  <div>
    <my-notification :icon="'lightbulb-o'">
      <template #title
        >{{ $t('compTransitionReviewerReviewPublished.published-actions') }}
      </template>
      <p>
        {{ $t('compTransitionReviewerReviewPublished.info') }}
      </p>
    </my-notification>

    <b-notification :closable="false">
      <b-collapse :open="false" aria-id="contentIdForA11y1">
        <template #trigger="props">
          <b-icon icon="filter" size="is-medium" type="is-black" />
          {{ $t('compTransitionReviewerReviewPublished.filter') }}
          <b-icon :icon="props.open ? 'caret-down' : 'caret-up'"> </b-icon>
        </template>
        <br />
        <filter-items @filtered="filtered"></filter-items>
      </b-collapse>
    </b-notification>
    <table-items
      :fullscreen="fullscreen"
      :items="items"
      :count="count"
      @onOpenItem="openAction"
      @onClickFile="clickFile"
      @onLoadMore="loadMore"
    >
    </table-items>
  </div>
</template>

<script>
import transitionService from '@/services/transitionService'
import { BackendFilter } from '@/mixins/backendfilter.js'
import { PublicAction } from '@/models/transition/transition'
import { openFileAsync } from '../../../models/transition/utils'

export default {
  name: 'Maps',
  components: {
    'my-notification': () => import('@/components/MyNotification.vue'),
    'table-items': () => import('@/components/transition/maps/TableItems.vue'),
    'filter-items': () => import('@/components/transition/maps/FilterItems.vue')
  },
  props: {
    fullscreen: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  mixins: [BackendFilter],
  data: function () {
    return {
      ItemClass: () => PublicAction,
      getNextFnc: (next) => transitionService.getNextPublishedActions(next),
      getItems: (filters) => transitionService.getPublishedActions(filters),
      openAction: (action) => {
        let route = this.$router.resolve({
          // The only difference here compared to maps is here
          // we want to redirect to the reviewing area
          path: `/transition-1point5/reviewer/actions/${action.id}`
        })
        window.open(route.href, '_blank')
      },
      clickFile: (file) => {
        if (file.url) {
          openFileAsync(transitionService.getFile(file), file.name)
        }
      }
    }
  },
  mounted () {
    this.filterAll()
  }
}
</script>
